import { useState } from "react";

import SwapVertIcon from "@mui/icons-material/SwapVert";
import { Button, Menu, MenuItem } from "@mui/material";

import { THEME_SORT_BY } from "../constants";


const SortPopup = ({ sortBy, onChange, disabled, className }) => {

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);
  const handleMenuClick = (event, item) => {
    onChange && onChange(item);
    handleClose(event);
  };
  return <div className={className}> 
    <div className="flex items-center gap-1">
      {sortBy ? <span className="capitalize text-sm">Sort By: {sortBy}</span>: null}
      <Button onClick={handleClick} size="small" startIcon={<SwapVertIcon />} disabled={disabled} >Sort</Button>
    </div>
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
    >
      <MenuItem onClick={(event) => handleMenuClick(event, THEME_SORT_BY.COMMENTS)}>Comments</MenuItem>
      <MenuItem onClick={(event) => handleMenuClick(event, THEME_SORT_BY.FAVORABILITY)}>Favorable</MenuItem>
      <MenuItem onClick={(event) => handleMenuClick(event, THEME_SORT_BY.UNFAVORABILITY)}>Unfavorable</MenuItem>
    </Menu>
  </div>;

};

export default SortPopup;
